import React, { useState, useEffect } from 'react'
import { FcOk } from 'react-icons/fc'

function PaymentSuccessful() {

  const [seconds, setSeconds] = useState(3)

  useEffect(() => {

    setTimeout(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      else {
        window.location.href = "/dashboard"
      }
    }, 1000)
  })

  return (
    <div className="container">

      <div className="row justify-content-center align-items-center" style={{height: '100vh'}}>
        <div class="col-8 col-md-4 col-lg-4 col-xl-4">
          <div className="payment-form-body">
            <div className="payment-success">
              <div className="payment-success-body text-center">
                <div className="success-icon mb-4">
                  <span style={{ fontSize: '50px' }}><FcOk /></span>
                </div>
                <div className="success-title">
                  <h4 className="font-weight-bolder text-uppercase font-dark">Payment Successful</h4>
                  <p className="text-secondary">Thank you! We have received your Payment</p>
                  <p className="mb-5 text-secondary">The page will redirect in {seconds} seconds</p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default PaymentSuccessful
